__turbopack_context__.v({
  "company-name": "d7vk9a_company-name",
  "container": "d7vk9a_container",
  "designations": "d7vk9a_designations",
  "full-name": "d7vk9a_full-name",
  "full-name-secondary": "d7vk9a_full-name-secondary",
  "grace-period-indicator": "d7vk9a_grace-period-indicator",
  "info-row": "d7vk9a_info-row",
  "location": "d7vk9a_location",
  "separator": "d7vk9a_separator",
  "separator__line": "d7vk9a_separator__line",
  "welcome": "d7vk9a_welcome",
});
